var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_CACHE_TIME = 1000 * 30;
const localforage = (() => {
    let store = {};
    const setItem = (key, value) => {
        store[key] = value;
        return value;
    };
    const getItem = (key) => {
        return store[key];
    };
    const removeItem = (key) => {
        store[key] = undefined;
    };
    const keys = () => Object.keys(store);
    const clear = () => {
        store = {};
    };
    return {
        setItem,
        getItem,
        removeItem,
        keys,
        clear,
    };
})();
export const set = (key, value, options) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof options !== 'object')
        options = {};
    const cacheValue = {
        data: value,
        insertTime: Date.now(),
        duration: options.duration ? options.duration : DEFAULT_CACHE_TIME,
    };
    const val = yield localforage.setItem(key, cacheValue);
    return val.data;
});
const isExpired = (data) => Date.now() > data.insertTime + data.duration;
export const get = (key) => __awaiter(void 0, void 0, void 0, function* () {
    const val = yield localforage.getItem(key);
    if (val == null)
        return undefined;
    if (isExpired(val)) {
        invalidate(key);
        return undefined;
    }
    return val.data;
});
export const invalidate = (key) => __awaiter(void 0, void 0, void 0, function* () {
    return yield localforage.removeItem(key);
});
export const prune = () => __awaiter(void 0, void 0, void 0, function* () {
    const names = yield localforage.keys();
    for (let i = 0; i < names.length; i++) {
        const key = names[i];
        const data = yield localforage.getItem(key);
        if (isExpired(data)) {
            invalidate(key);
        }
    }
});
export const nuke = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield localforage.clear();
});
//# sourceMappingURL=cache.js.map